export default "__VITE_ASSET__BkrNggNQ__"